import { addMonths as a } from "./addMonths.js";
function o(r, t) {
  return a(r, t * 12);
}
export {
  o as addYears,
  o as default
};
//# sourceMappingURL=addYears.js.map
